<template>
  <div class="site-create-form">
    <div class="title">补充基础信息</div>
    <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form">
      <el-form-item label="店铺名称" class="item-content" prop="name">
        <el-input v-model="form.name" class="item-input" placeholder="例如:Patricia Gutkowski"></el-input>
      </el-form-item>
      <el-form-item label="行业" class="item-content" prop="category">
        <el-select v-model="form.category" multiple placeholder="请选择行业" class="item-input">
          <el-option v-for="item in cateOptions" :label="item.dictItemKey" :value="item.dictItemValue" :key="item.dictItemValue"></el-option>
        </el-select>
      </el-form-item>
      <div class="desc">站点复制内容包括：商品、商品系列、网站地图、文章、站点装修、营销活动、配送设置、弹窗通知。</div>
      <el-form-item style="text-align: right;margin-bottom: 0;">
        <el-button type="primary" :loading="loading" @click="handleForm">创建站点</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {postMerchantConfig, copyShop, queryCopyShopStatus, dictionaryData} from '@/server/common'
import Cookies from 'js-cookie'

export default {
  name: 'SiteCreateForm',
  props: {
    title: String,
  },
  data() {
    const checkSite = (rule, value, callback) => {
      if (value && !/^[a-zA-Z0-9-]+$/.test(value)) {
        return callback(new Error('请输入英文字符'))
      } else if (!value || value.length > 70) {
        return callback(new Error('请输入70字以下店铺名称'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        name: [{required: true, validator: checkSite, trigger: 'blur'}],
        category: [{required: true, type: 'array', message: '请选择所在行业', trigger: 'blur'}],
      },
      cateOptions: [],
      loading: false,
      form: {
        name: '',
        category: '',
      },
    }
  },
  created() {
    this.getItems()
  },
  methods: {
    handleCancel() {
      // this.visible = false
    },
    async getItems() {
      const {data} = await dictionaryData('operate_category')
      console.log(data)
      if (data.code === this.$code) {
        this.cateOptions = data.data
      }
    },
    handleForm() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.loading = true
          const params = {...this.form}
          params.category = params.category.join(',')
          const {data} = await copyShop(params)

          if (data.code === this.$code) {
            this.$message.success('复制进行中，请稍后尝试查询数据。')
            Cookies.set('copyingShop', data.data.taskId, {expires: 365})
            this.$emit('change-taskId', data.data.taskId)
            this.$emit('cancel-fn')
          }
          this.loading = false
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.site-create-form {
  .title { margin-bottom: 14px; }
  .item-input { width: 100%; }
  .desc {
    font-size: 14px;
    color: #9DA1C3;
    margin-bottom: 72px;
  }
}
</style>
